var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkle24 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.128 5.664a8.013 8.013 0 0 1-4.464 4.464l-3.286 1.314a.601.601 0 0 0 0 1.116l3.286 1.314a8.013 8.013 0 0 1 4.464 4.464l1.314 3.286a.601.601 0 0 0 1.116 0l1.314-3.286a8.013 8.013 0 0 1 4.464-4.464l3.286-1.314a.601.601 0 0 0 0-1.116l-3.286-1.314a8.013 8.013 0 0 1-4.464-4.464l-1.314-3.286a.601.601 0 0 0-1.116 0l-1.314 3.286ZM12 6.376l-.013.032a10.016 10.016 0 0 1-5.58 5.58l-.03.012.03.013a10.015 10.015 0 0 1 5.58 5.58l.013.03.013-.03a10.015 10.015 0 0 1 5.58-5.58l.03-.013-.03-.013a10.015 10.015 0 0 1-5.58-5.58L12 6.378Z",
    fill: "currentColor"
  })));
};
export default SvgSparkle24;